import { Component, Input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { RoadOccupationStageForm } from '../../forms/road-occupation-stage.form';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { DatePickerComponent } from '../../../../../../../common/date-picker/date-picker.component';
import { AlertComponent } from '../../../../../../../common/alert/alert.component';
import {
  ExposedMapControlComponent
} from '../../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { ParcelsCrudComponent } from '../../../components/parcels/parcels-crud/parcels-crud.component';
import {
  DictTownRoadItem, DictTownStreetItem,
  DictTownWithRoadsItem,
  DictTownWithStreetsItem
} from '../../../../../../../services/dictionary.common.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { DictionaryCommonService } from '../../../../../../../services/dictionary.common.service';

@Component({
  selector: 'app-stage-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    NgxMaskDirective,
    DatePickerComponent,
    AlertComponent,
    ExposedMapControlComponent,
    ParcelsCrudComponent
  ],
  templateUrl: './stage-form.component.html'
})
export class StageFormComponent {

  @Input()
  public label: string = '';

  @Input()
  public form: RoadOccupationStageForm | undefined;

  @Input()
  public canRemoveStage = true;

  public townWithStreetsList: Signal<DictTownWithStreetsItem[] | undefined> = toSignal(this.dictService.getTownWithStreetsList());

  public townWithRoadsList: Signal<DictTownWithRoadsItem[] | undefined> = toSignal(this.dictService.getTownWithRoadsList());

  public getRoadList(townName?: string | null): Array<DictTownRoadItem> {
    return this.townWithRoadsList()?.filter(v => v.name === townName).at(0)?.roads || [];
  }

  public getStreetList(townName?: string | null): Array<DictTownStreetItem> {
    return this.townWithStreetsList()?.filter(v => v.name === townName)?.at(0)?.streets || [];
  }

  constructor(private dictService: DictionaryCommonService) {
  }

  public roadNumberChange(roadNumber: string): void {
    const roadName = this.getRoadList(this.form?.city.value).filter(v => v.roadNumber === roadNumber).at(0)?.roadName || '';
    this.form?.roadName?.setValue(roadName);
  }
}
